<template>
  <SelectMultipleInput
    v-model="model"
    :items="items"
    item-text="reasonName"
    item-value="reasonCd"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'SaReasonMultipleInput',

  mixins: [APIUtils, Message],

  components: {
    SelectMultipleInput,
  },

  props: {
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0222')
      },
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  async mounted() {
    this.loading = true
    try {
      let params = {}
      if (this.validOnly) {
        params.validOnly = true
      }

      this.items = await API.get('/master/sa/reasonOfApplication', params)
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0222') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
